<template>
  <main class="container py-5" style="max-width: 520px">
    <h1 class="mb-4">C'est qui ? </h1>
    <p v-if="error" role="alert" class="text-danger">{{ error }}</p>
    <button class="btn btn-primary" :disabled="busy" @click="connect">
      {{ busy ? 'Validation en cours…' : 'Se connecter' }}
    </button>
    <p class="mt-4"><router-link to="/activate">1ère connexion</router-link></p>
  </main>
</template>
<script>
import {usePasskey} from '../services/AuthService';
export default {
  data: () => ({busy: false, error: ''}),
  methods: {
    async connect() {
      this.busy = true;
      this.error = '';
      try {
        await usePasskey();
        await this.$router.replace('/');
      } catch (error) { this.error = error.message; }
      finally { this.busy = false; }
    }
  }
};
</script>

<style scoped>
main {
    text-align: center;
    align-content: center;
}
</style>